import { createTheme } from '@ncr-design-system/shared-frontend'

export const theme = createTheme()
